export const ArrowRightPagination = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="8" viewBox="0 0 4 8" fill="none">
      <path d="M0.666504 7.33341V0.666748L3.99984 4.00008L0.666504 7.33341Z" fill="currentColor" />
    </svg>
  )
}
